import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppError } from "types/app/error";

const ErrorPage = () => {
  const location = useLocation();

  const errorText = useMemo(() => {
    const handlers = [
      {
        predicate: () => location.state?.errorType === AppError.APP,
        handler: () =>
          "Unexpeceted error happened, you can proceed with navigation.",
      },
      {
        predicate: () => location.state?.errorType === AppError.NOT_FOUND_PAGE,
        handler: () =>
          language?.footer?.error_text ??
          "Sorry! The page you were looking for doesn't exist.",
      },
      {
        predicate: () =>
          location.state?.errorType === AppError.NOT_FOUND_CONTENT,
        handler: () => "Sorry! The content you were looking for doesn't exist.",
      },
      {
        predicate: () => location.state?.errorType === AppError.NOT_FOUND_PAGE,
        handler: () =>
          language?.footer?.error_text ??
          "Sorry! The page you were looking for doesn't exist.",
      },
    ];
    return handlers.find(({ predicate }) => predicate())?.handler();
  }, []);

  const language = useSelector((state: any) => state.languagesState.languages);
  return (
    <div className="not-found-wrap text-center">
      <h1 className="text-60">404</h1>
      <p className="text-36 subheading mb-3">
        {language?.footer?.error ?? "Errors!"}
      </p>
      <p className="mb-5  text-muted text-18">
        {errorText}
      </p>
    </div>
  );
};

export default ErrorPage;
